import * as backend from "./backend";
import * as util from "../util";

export interface FileRef {
  ref: string;
  url: string;
  loading: boolean;
  error: boolean;
}

export function newFileRef(ref: string): FileRef {
  return {
    ref,
    url: "",
    loading: false,
    error: false
  };
}

export async function resolveFile(file: FileRef) {
  if (file.url) {
    return;
  }
  file.loading = true;
  file.error = false;
  try {
    if (file.ref) {
      const logoURL = await backend.getStorageURL(file.ref);
      file.url = logoURL;
    } else {
      file.url = "";
    }
  } catch (err) {
    util.logError("Error downloading image", err);
    file.error = true;
  }
  file.loading = false;
}

export async function resolveRefToURL(fileRef?: string): Promise<string> {
  if (!fileRef) {
    return "";
  }
  return backend.getStorageURL(fileRef);
}
